module.exports = __webpack_public_path__ + "static/media/1016490646-preview.7441f17d.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/landing/1016490646-preview.mp4
// module id = 1814
// module chunks = 0